/* eslint-disable react/jsx-key */
import React, { useState } from 'react';
import SidePanel, { SidePanelHeader } from '../../../../components/SidePanel';

import DrawerFilterType from './DrawerFilterType';
import Form from '../../../../components/Form';

import {
  FiltersContainer,
  FilterContainer,
  SidePanelContainer,
  FilterContainerOverLay,
  OverLay,
} from './styles';

const FilterDrawer = ({
  onDismiss,
  filters,
  onFilter,
  currentFilters,
  isNextPageLoading,
  loadNextPage,
}) => {
  const [currentOpenedFilter, setCurrentOpnendFilter] = useState(false);

  const _toggleOverlay = filterName =>
    setCurrentOpnendFilter(filterName || false);

  const _onChange = (newValue, onChangeFunction) => {
    onChangeFunction(newValue);
  };

  const _renderFilters = () =>
    filters.map(filter => (
      <FilterContainer>
        <DrawerFilterType
          isNextPageLoading={isNextPageLoading}
          loadNextPage={(startIndex, stopIndex) => {
            loadNextPage(filter.filterType, startIndex, stopIndex);
          }}
          hasNextPage={
            currentFilters[filter.filterType]
              ? currentFilters[filter.filterType].hasNextPage
              : null
          }
          filterType={filter.filterType}
          type={filter.type}
          name={filter.identifier}
          options={filter.options}
          value={filter.currentValue}
          placeholder={filter.placeholder}
          isOpen={currentOpenedFilter === filter.identifier}
          onChange={newValue => _onChange(newValue, filter.onChange)}
          toggleOverlay={_toggleOverlay}
          alwaysShowPlaceholder
          renderLeft={filter.renderLeft}
          onClear={filter.onClear}
          identifier={filter.identifier}
          currentValue={filter.currentValue || filter.label}
          onSearchByTerm={filter.onSearchByTerm}
          searchTerm={
            currentFilters[filter.filterType]
              ? currentFilters[filter.filterType].searchTerm
              : null
          }
        />
      </FilterContainer>
    ));

  return (
    <div>
      <SidePanelContainer>
        <SidePanel>
          <SidePanelHeader title="Filtrar" onDismiss={onDismiss} />
          <FiltersContainer>
            {currentOpenedFilter && (
              <FilterContainerOverLay
                className="FilterContainer__overlay"
                onClick={() => _toggleOverlay(false)}
              />
            )}
            <Form
              className="FilterWrapper FilterWrapper__big"
              actionBarClassName="DrawerFilters__action-bar"
              submitText="ver resultados"
              onSubmit={() => {
                onFilter();
                onDismiss();
              }}
            >
              {_renderFilters()}
            </Form>
          </FiltersContainer>
        </SidePanel>
      </SidePanelContainer>
      <OverLay onClick={() => onDismiss()} />
    </div>
  );
};

export default FilterDrawer;
